/**
 * Parent-side message handler — receives height updates from iframe
 * Double-rAF + forced reflow for Safari compatibility
 */
import { debugLog } from './utils';
export const handleHeightUpdate = (iframe, message, config, logPrefix) => {
    const { debugMode, onHeightUpdate } = config;
    const { height, widgetId } = message;
    debugLog(debugMode, logPrefix, 'Received height:', height, 'for', widgetId);
    const heightPx = height + 'px';
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            iframe.style.height = heightPx;
            iframe.style.minHeight = heightPx;
            iframe.style.maxHeight = 'none';
            void iframe.offsetHeight;
            void iframe.getBoundingClientRect();
        });
    });
    if (onHeightUpdate) {
        onHeightUpdate(widgetId || iframe.id, height);
    }
};
export const handleScrollToTop = (iframe, message, config, logPrefix) => {
    const { debugMode, onScrollRequest } = config;
    const { widgetId } = message;
    debugLog(debugMode, logPrefix, 'Scroll to top for', widgetId);
    iframe.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (onScrollRequest) {
        onScrollRequest(widgetId || iframe.id);
    }
};
export const createMessageHandler = (config, logPrefix, hashScroll) => {
    return (event) => {
        if (!event.data || typeof event.data !== 'object' || !event.data.type)
            return;
        const widgetId = event.data.widgetId;
        if (!widgetId)
            return;
        const iframe = document.getElementById(widgetId);
        if (!iframe || iframe.tagName !== 'IFRAME')
            return;
        const expectedOrigin = new URL(iframe.src).origin;
        if (event.origin !== expectedOrigin)
            return;
        switch (event.data.type) {
            case 'TWIPOINT_IFRAME_HEIGHT':
                handleHeightUpdate(iframe, event.data, config, logPrefix);
                hashScroll?.scheduleRestore();
                break;
            case 'TWIPOINT_SCROLL_TO_TOP':
                handleScrollToTop(iframe, event.data, config, logPrefix);
                break;
        }
    };
};
